import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import Dropdown from 'components/dropdown/Dropdown';
import {useUserContext} from 'context/index';
import {useDispatchPost} from 'redux/hooks/fetch';
import {fetchFilteredHomeReports} from 'routes/home/fetchFilteredHomeReports';

const useStyles = makeStyles(theme => ({
	textButton: {
		fontFamily: 'Montserrat',
		textTransform: 'capitalize',
		fontSize: 14,
		[theme.breakpoints.down('1300')]: {
			fontSize: 12,
		},
	},
}));

function ChartsMenuDropdown() {
	//<<
	const classes = useStyles();
	const [charts, setCharts] = useState([]);

	const {
		clientId,
		_id: userId,
		groupType: userGroupType,
		groupId: userGroupId,
		canAccessReports,
		manager,
	} = useUserContext();

	const post = useDispatchPost();

	useEffect(() => {
		if (!clientId) return;

		fetchFilteredHomeReports(post, {
			clientId,
			userGroupType,
			userGroupId,
			userId,
			canAccessReports,
			manager,
		})
			.then(sortedCharts => setCharts(sortedCharts))
			.catch(err => {
				console.error('Error fetching reports from backend:', err);
				setCharts([]);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [clientId, userGroupType, userGroupId, userId, canAccessReports, manager]);

	return (
		<Dropdown
			hasArrow={true}
			label='Dashboards'
			labelEmpty={'Nenhum relatório disponível'}
			itensList={charts}
			className={classes.textButton}
			dataTour='tour_home_menu_dashboard'
			openNewTab={true}
		/>
	);
}

export default ChartsMenuDropdown;
